<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">ABM Administradores</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-0 p-md-3 mb-0 align-items-center pt-1">
            <div class="mt-0 text-start mb-3 pb-3">
                <div class="d-grid mb-3 p-2">
                    <button type="button" class="btn btn-primary btn-lg mt-0" [routerLink]="['/more-administrador']">
                        <span class="icon">+ </span>
                        <span class="text">Agregar Administrador</span>
                    </button>
                </div>

                <div class="row-cols-12 p-2 mb-3 ps-0 pe-0 input-group fade-in search-input-row">
                    <div class="rounded-start col-md-auto" id="search-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
                    </div>
                    <div class="col rounded">
                        <input
                            type="search"
                            class="form-control search-input shadow-none"
                            placeholder="Buscar por email, nombre, apellido o documento"
                            aria-label="Search"
                            aria-describedby="search-addon"
                            (keyup)="searchTerm$.next($any($event.target).value)"
                        />
                    </div>
                    <div class="col-md-auto rounded-end text-end" id="mic-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-mic"></i></div>
                    </div>
                </div>

                @if (error()) {
                    <div class="alert alert-danger mt-4" role="alert">
                        <small>{{ error() }}</small>
                    </div>
                }
                @if (message()) {
                    <div class="alert alert-success mt-4" role="alert">
                        <small>{{ message() }}</small>
                    </div>
                }

                <span class="p-0 m-0">
                    <b>Administradores ({{ (usuariosFiltradas$ | async)?.length ?? 0 }})</b>
                </span>
                @for (usuario of (usuariosFiltradas$ | async) ?? []; track usuario.id) {
                    <div class="administrador-card mt-3 form-switch">
                        <a
                            class="text-decoration-none text-dark flex-grow-1 overflow-hidden"
                            [routerLink]="['/more-edit-administrador', usuario.id]"
                        >
                            <div class="administrador-title text-truncate">
                                {{ usuario.x_email }}
                            </div>

                            <div class="administrador-subtitle text-truncate">
                                {{ usuario.cliente?.x_nombre || 'Sin nombre' }}
                                {{ usuario.cliente?.x_apellido || '' }}
                            </div>

                            @if (usuario.x_nro_documento) {
                                <div class="administrador-extra text-truncate">
                                    Documento: {{ usuario.x_nro_documento }}
                                </div>
                            }
                        </a>

                        <div class="col-2">
                            <a
                                class="administrador-action"
                                [routerLink]="['/more-edit-administrador', usuario.id]"
                            >
                                <i class="bi bi-pencil"></i>
                            </a>
                        </div>

                        <div class="col-auto">
                            <input
                                class="form-check-input"
                                [id]="'administrador-' + usuario.id"
                                type="checkbox"
                                [checked]="usuario.b_activo"
                                (change)="activarDesactivar(usuario, $any($event.target).checked)"
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>